const NODE_ENV = process.env.NODE_ENV;
function consolelog(val){}
const funcDebug = NODE_ENV === 'development' ? console.log : consolelog;
export default funcDebug;  